import React, { useState, useEffect } from "react";
import "./Submission.css";
import "./Body.css";
import TopNav from "./TopNav";
import {useDataLayerValue} from "./DataLayer";
import PoweredBy from "./Powered";

const API_URL = 'https://your-api-url.deno.dev'; // Replace with your actual API URL

function Submission({ spotifyApi }) {
  const [
    { volume, player, playback },
    dispatch,
  ] = useDataLayerValue();

	const [isApiOpen, setIsApiOpen] = useState(false);
	const [currentTimeInfo, setCurrentTimeInfo] = useState(null);
	const [spotifyUrl, setSpotifyUrl] = useState("");
	const [statusMessage, setStatusMessage] = useState("");
	const [statusType, setStatusType] = useState("");
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [showStatus, setShowStatus] = useState(false);

	const test = false;

	// Check if API is open (Friday 17:00 - Saturday 23:59 Warsaw time)
	const checkApiStatus = (testMode) => {
		const now = new Date();
		const warsawTime = new Date(now.toLocaleString("en-US", { timeZone: "Europe/Warsaw" }));
		const day = warsawTime.getDay(); // 0 = Sunday, 5 = Friday, 6 = Saturday
		const hour = warsawTime.getHours();

		// Friday after 17:00 or entire Saturday
		const open = testMode ? true : (day === 5 && hour >= 17) || (day === 6);
		setIsApiOpen(open);

		const timeInfo = {
			dayName: warsawTime.toLocaleDateString("en-US", { weekday: "long", timeZone: "Europe/Warsaw" }),
			timeString: warsawTime.toLocaleTimeString("en-US", {
				timeZone: "Europe/Warsaw",
				hour12: false,
				hour: "2-digit",
				minute: "2-digit"
			}),
			fullDateTime: warsawTime.toLocaleString("en-US", {
				timeZone: "Europe/Warsaw",
				weekday: "long",
				year: "numeric",
				month: "long",
				day: "numeric",
				hour: "2-digit",
				minute: "2-digit",
				hour12: false
			})
		};
		setCurrentTimeInfo(timeInfo);
	};

	// Get next opening time
	const getNextOpeningTime = () => {
		const now = new Date();
		const warsawTime = new Date(now.toLocaleString("en-US", { timeZone: "Europe/Warsaw" }));
		const day = warsawTime.getDay();

		if (day < 5 || (day === 5 && warsawTime.getHours() < 17)) {
			// Before Friday 17:00 - next opening is this Friday 17:00
			return `This Friday at 17:00 CET/CEST (European)`;
		} else {
			// After Saturday - next opening is next Friday 17:00
			return `Next Friday at 17:00 CET/CEST (European)`;
		}
	};

  const logout = (event) => {
    // Clear the correct localStorage key (App.js uses "spotify_token")
    localStorage.removeItem("spotify_token");

    // Use the LOGOUT action which properly resets state
    dispatch({
      type: "SET_TOKEN",
      payload: null,
    });

    // dispatch({
    //   type: "LOGOUT",
    // });
  }

	// Show status message
	const showMessage = (message, type) => {
		setStatusMessage(message);
		setStatusType(type);
		setShowStatus(true);

		setTimeout(() => {
			setShowStatus(false);
		}, 5000);
	};

	// Handle form submission
	const handleSubmit = async (e) => {
		e.preventDefault();

		const trimmedUrl = spotifyUrl.trim();

		if (!trimmedUrl) {
			showMessage('Please enter a Spotify track URL', 'error');
			return;
		}

		// Validate Spotify URL format
		if (!trimmedUrl.includes('spotify.com/track/')) {
			showMessage('Please enter a valid Spotify track URL', 'error');
			return;
		}

		// Show loading state
		setIsSubmitting(true);

		try {
			const response = await fetch(`${API_URL}/add-track`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					url: trimmedUrl
				})
			});

			const data = await response.json();

			if (response.ok) {
				showMessage('✅ Track added successfully to the playlist!', 'success');
				setSpotifyUrl('');
			} else {
				showMessage(`❌ ${data.error || 'Failed to add track'}`, 'error');
			}

		} catch (error) {
			showMessage('❌ Network error. Please try again.', 'error');
		} finally {
			setIsSubmitting(false);
		}
	};

	// Initialize and update every minute
	useEffect(() => {
		checkApiStatus(test);

		// Update every minute
		const interval = setInterval(() => {
			checkApiStatus(test);
		}, 60000);

		return () => clearInterval(interval);
	}, []);

	return (
		<div className="body submission">
			<div className="floating-notes">
				<div className="note" style={{ left: "10%", animationDelay: "0s" }}>♪</div>
				<div className="note" style={{ left: "20%", animationDelay: "2s" }}>♫</div>
				<div className="note" style={{ left: "30%", animationDelay: "4s" }}>♪</div>
				<div className="note" style={{ left: "40%", animationDelay: "1s" }}>♬</div>
				<div className="note" style={{ left: "50%", animationDelay: "3s" }}>♪</div>
				<div className="note" style={{ left: "60%", animationDelay: "5s" }}>♫</div>
				<div className="note" style={{ left: "70%", animationDelay: "7s" }}>♪</div>
				<div className="note" style={{ left: "80%", animationDelay: "6s" }}>♬</div>
				<div className="note" style={{ left: "90%", animationDelay: "8s" }}>♪</div>
			</div>

			<div className="submission__container">
				{/*<h1 className="submission__logo">Weeekly Vibes ♪</h1>*/}
				{/*<p className="submission__subtitle">Share your track for the weekly playlist</p>*/}

				<div className="submission__card">
					{isApiOpen ? (
						<form id="spotify-form" onSubmit={handleSubmit}>
							<div className="submission__form-group">
								<div className="submission__input-wrapper">
									<input
										type="url"
										id="spotify-url"
										placeholder="Paste your Spotify track link here..."
										value={spotifyUrl}
										onChange={(e) => setSpotifyUrl(e.target.value)}
										required
									/>
								</div>
							</div>
							<button 
								type="submit" 
								className="submission__submit-btn" 
								disabled={isSubmitting}
							>
								{isSubmitting ? (
									<>
										<span className="submission__loading"></span> Adding to playlist...
									</>
								) : (
									'Add to Playlist'
								)}
							</button>
							<div 
								className={`submission__status-message ${statusType} ${showStatus ? 'show' : ''}`}
							>
								{statusMessage}
							</div>
						</form>
					) : (
						<div className="submission__closed-info">
							<h2 className="submission__closed-title">Playlist Submissions Closed</h2>
							<div className="submission__schedule">
								Open Hours: <br /> Friday 17:00 - Saturday 23:59
							</div>
							{currentTimeInfo && (
								<div className="submission__current-time">
									Current time: {currentTimeInfo.fullDateTime}
								</div>
							)}
							<div className="submission__next-opening">
								Next opening: {getNextOpeningTime()}
							</div>
						</div>
					)}
				</div>

				<div className="submission__disclaimer">
					<div>
						<strong>Important:</strong>
					</div>
					<div>
						Each artist can appear only once on the playlist (whether as a solo artist or featured).
					</div>
				</div>
			</div>

      {/*	loggout button */}
      <button
        onClick={logout}
        style={logoutButtonStyle}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#f9fafb';
          e.target.style.color = '#374151';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = '#282828';
          e.target.style.color = '#eaeaea';
        }}
      >
        Logout
      </button>

      <PoweredBy/>
		</div>
	);
}

export default Submission;

const logoutButtonStyle = {
  padding: '6px 16px',
  fontSize: '14px',
  fontWeight: '500',
  border: '1px solid rgba(255, 255, 255, 0.2)',
  borderRadius: '8px',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  outline: 'none',
  fontFamily: 'inherit',
  backgroundColor: '#282828',
  color: 'white'
};

